import React, {useState} from 'react';
import {BaseEdge, EdgeLabelRenderer, getConnectedEdges, getSmoothStepPath, useReactFlow} from 'reactflow';
import {deleteRelation} from '../../service/relationApi';
import {t} from "i18next";
import {relationHandle} from "../../utils/relation";

const RelationEdge = ({id, data, markerEnd, markerStart, style, ...props}) => {
    const instance = useReactFlow();

    const getEdgeRoundedCornerOffset = (relationLabel) => {
        if (relationLabel === "siblings" || relationLabel === "husband-wife" || relationLabel === "wife-husband") {
            return 35;
        } else if (
            relationLabel === "adopted-son" || relationLabel === "adopted-daughter" || relationLabel === "son-in-law" ||
            relationLabel === "daughter-in-law" || relationLabel === "son" || relationLabel === "daughter"
        ) {
            return 70;
        } else {
            return 35;
        }
    }

    const [edgePath, labelX, labelY] = getSmoothStepPath({
        ...props,
        offset: getEdgeRoundedCornerOffset(data.relationshipType),
    });
    const [relationshipType, setRelationshipType] = useState(data.relationshipType);

    const deleteEdge = (evt) => {
        evt.stopPropagation();
        instance.setEdges((edges) => edges.filter((ed) => ed.id !== id));
    };

    const deleteEdgeFromDB = (evt) => {
        evt.stopPropagation();
        console.log("id: ", id);
        const reversedId = id.split('-').reverse().join('-');
        console.log("reversedId: ", reversedId);
        deleteRelation(id).then((res) => {
            if (res.status === 200) {
                deleteRelation(reversedId);
                instance.setEdges((edges) => edges.filter((ed) => (ed.id !== id && ed.id !== reversedId)));
            } else {
                console.log("Error occurred while Deleting Relation: ", res);
            }
        });
    };

    const getLabelTransformPosition = () => {
        const connectedEdges = getConnectedEdges([instance.getNode(props.source), instance.getNode(props.target)], instance.getEdges());

        // console.log("Connected Edges: ", connectedEdges);

        if (props.sourceHandleId === "a") {
            if (data.relationshipType === "siblings") {
                return `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`;
            } else if (connectedEdges.some((edge) => edge.data.relationshipType === "siblings")) {
                return `translate(-50%, -300%) translate(${props.sourceX}px, ${props.sourceY}px)`;
            } else {
                return `translate(-50%, -175%) translate(${props.sourceX}px, ${props.sourceY}px)`;
            }
        }

        if (props.sourceHandleId === "b") {
            if (data.relationshipType === "wife-husband" || data.relationshipType === "husband-wife" || data.relationshipType === "siblings") {
                return `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`;
            } else {
                return `translate(-125%, -50%) translate(${props.sourceX}px, ${props.sourceY}px)`;
            }
        }

        if (props.sourceHandleId === "c") {
            if (data.relationshipType === "wife-husband" || data.relationshipType === "husband-wife" || data.relationshipType === "siblings") {
                return `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`;
            } else {
                return `translate(25%, -50%) translate(${props.sourceX}px, ${props.sourceY}px)`;
            }
        }

        if (props.sourceHandleId === "d") {
            return `translate(-50%, 75%) translate(${props.sourceX}px, ${props.sourceY}px)`;
        }
    }

    // useEffect(() => {
    //     console.log("Relation Data: ", data);
    //     console.log("Relation Props: ", props);
    // }, []);

    return (
        <>
            <BaseEdge
                id={id}
                path={edgePath}
                markerEnd={markerEnd}
                markerStart={markerStart}
                style={{...style, strokeDashoffset: 10}}
                interactionWidth={20}
            />

            <EdgeLabelRenderer>
                <div
                    style={{
                        position: "absolute",
                        transform: getLabelTransformPosition(),
                        // transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                        backgroundColor: relationHandle[relationshipType].color
                    }}
                    className={`nodrag nopan px-[0.75vw] py-[0.75vh] rounded-full`}
                >
                    <p className={"text-[0.75vw] font-custom-mono-medium"}>
                        {t(`CONSTANTS.RELATIONSHIP.${relationshipType}`)}
                    </p>
                </div>

                <button
                    style={{
                        pointerEvents: "all",
                        position: "absolute",
                        transform: relationshipType === "husband-wife" || relationshipType === "wife-husband" || relationshipType === "siblings"
                            ? `translate(-50%, 50%) translate(${labelX}px, ${labelY}px)`
                            : `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`
                    }}
                    className={`nodrag nopan flex items-center justify-center rounded-full bg-red-400 w-[1vw] h-[1vw]`}
                    onClick={(event) => relationshipType ? deleteEdgeFromDB(event) : deleteEdge(event)}
                >
                    <img
                        src={"/assets/close-icon-dark.svg"}
                        className={"h-[75%] aspect-square"}
                        alt={"Delete Relation"}
                    />
                </button>
            </EdgeLabelRenderer>

            {/*<foreignObject*/}
            {/*    x={labelX}*/}
            {/*    y={labelY}*/}
            {/*    className={`flex items-center justify-center rounded-full bg-red-400 w-[1vw] h-[1vw] group`}*/}
            {/*    style={{*/}
            {/*        transform: 'translate(-50%, -50%)',*/}
            {/*    }}*/}
            {/*    // style={{*/}
            {/*    //     position: "absolute",*/}
            {/*    //     transform: relationshipType === "husband-wife" || relationshipType === "wife-husband" || relationshipType === "siblings"*/}
            {/*    //         ? `translate(${labelX}px, ${labelY}px)`*/}
            {/*    //         : `translate(${labelX}px, ${labelY}px)`*/}
            {/*    // }}*/}
            {/*    onClick={() => console.log("Delete Edge")}*/}
            {/*>*/}
            {/*    <button*/}
            {/*        // onClick={(event) => relationshipType ? deleteEdgeFromDB(event) : deleteEdge(event)}*/}
            {/*    >*/}
            {/*        <img*/}
            {/*            src={"/assets/close-icon-dark.svg"}*/}
            {/*            className={"h-[75%] aspect-square"}*/}
            {/*            alt={"Delete Relation"}*/}
            {/*        />*/}
            {/*    </button>*/}
            {/*</foreignObject>*/}
        </>
    );
};

export default RelationEdge;
